<template>
  <v-layout column>
    <v-flex xs3 offset-xs5 class="pt-5">
      <div class="white elevation-2">
        <v-toolbar flat dense color="blue darken-3" dark>
          <v-toolbar-title>Login</v-toolbar-title>
        </v-toolbar>
      </div>
      <form
        name="register-form"
        autocomplete="off">
          <div class="elevation-2 pl-4 pr-4 pt-2 pb-2">
            <v-text-field
              label="Username"
              type="text"
              v-model="username"
            ></v-text-field>
            <div class="red">{{usernameerror}}</div>
            <br>
            <v-text-field
              label="Password"
              type="password"
              v-model="password"
            ></v-text-field>
            <div class="red">{{passworderror}}</div>
            <br>
            <v-btn type="submit" color="blue darken-3" dark v-on:click="login">Login</v-btn>
        </div>
    </form>
    </v-flex>
  </v-layout>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data () {
    return {
      username: '',
      usernameerror: '',
      password: '',
      passworderror: ''
    }
  },
  methods: {
    async login () {
      console.log('login')
      try {
        const response = await AuthenticationService.login({
          username: this.username,
          password: this.password
        })
        console.log('response data')
        console.log(response.data)
        this.$store.dispatch('login', response.data)
        // this.$store.dispatch('setUser', response.data.user)
        this.$store.dispatch('fetchApplicationslistsubmitted')
        this.$store.dispatch('fetchApplicationslistpending')
        this.$store.dispatch('fetchApplicationslistpending')
        this.$store.dispatch('fetchCrops')
        this.$store.dispatch('fetchCountries')
        this.$router.push('dashboard')
      } catch (error) {
        var errordata = error.response.data
        // this.error = errordata
        this.usernameerror = ''
        this.passworderror = ''
        for (var i = 0; i < errordata.length; i++) {
          console.log(errordata[i].field)
          if (errordata[i].field === 'username') {
            this.usernameerror = errordata[i].message
          }
          if (errordata[i].field === 'password') {
            this.passworderror = errordata[i].message
          }
        }
      }
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/homepage/Login.vue